module.exports = __webpack_public_path__ + "img/bodypart.4fcf9a0c.svg";